import { render } from "./FirstTimerPerformanceReport.vue?vue&type=template&id=f71d77fe&scoped=true"
import script from "./FirstTimerPerformanceReport.vue?vue&type=script&lang=js"
export * from "./FirstTimerPerformanceReport.vue?vue&type=script&lang=js"

import "./FirstTimerPerformanceReport.vue?vue&type=style&index=0&id=f71d77fe&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f71d77fe"]])

export default __exports__